import {StoreItemCategory} from './entity_datas/StoreEnums'
// eslint-disable-next-line max-len
import {SIColorMysticBlue, SIColorPurple, SIColorWhite, SIExpansionCitiesAndKnights4P, SIExpansionCitiesAndKnights56P, SIExpansionCitiesAndKnightsSeafarers4P, SIExpansionCitiesAndKnightsSeafarers56P, SIExpansionClassic56P, SIExpansionClassic78P, SIExpansionSeafarers4P, SIExpansionSeafarers56P, SIIconFarmer, SIIconHelmet, SIIconScarf, SIIconSnorkel, SIIconSombrero, SIIconTie, SIIconWorker, SIMapBlackForest, SIMapDiamond, SIMapEarth, SIMapGear, SIMapGoldRush, SIMapLakes, SIMapPond, SIMapShuffleBoard, SIMapTwirl, SIMapUK, SIMapUSA, SIMapVolcano} from './store/StoreItemList'
import {BaseStoreItem} from './store/BaseStoreItem'
import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {ShareActivityLinkAnalytics} from './entity_datas/EntityDatas'

export interface ReferralReward {
    referralCount: number
    storeItemCategory: StoreItemCategory
    possibleRewards: BaseStoreItem[]
    name: TranslationObject
    image: LobbyImage
    analyticsPopupTriggered: ShareActivityLinkAnalytics
    analyticsPopupSuccess: ShareActivityLinkAnalytics
}

export class ReferralProgram {
    static readonly referralRewardLevels: ReferralReward[] = [
        {
            referralCount: 1,
            storeItemCategory: StoreItemCategory.Icon,
            possibleRewards: [new SIIconSombrero(), new SIIconFarmer(), new SIIconWorker(), new SIIconHelmet(), new SIIconScarf(), new SIIconSnorkel(), new SIIconTie()],
            name: {key: 'strings:storePage.sections.avatar.title', options: {context: 'other'}},
            image: LobbyImage.Avatars,
            analyticsPopupTriggered: ShareActivityLinkAnalytics.ReferralProgramStorePopupTriggeredLevel1,
            analyticsPopupSuccess: ShareActivityLinkAnalytics.ReferralProgramStoreSuccessfullySharedLevel1,
        },
        {
            referralCount: 5,
            storeItemCategory: StoreItemCategory.Map,
            possibleRewards: [new SIMapEarth(), new SIMapUSA(), new SIMapUK(), new SIMapDiamond(), new SIMapGear(), new SIMapLakes(), new SIMapPond(), new SIMapTwirl(), new SIMapShuffleBoard(), new SIMapBlackForest(), new SIMapVolcano(), new SIMapGoldRush()],
            name: {key: 'strings:storePage.sections.map.title', options: {context: 'other'}},
            image: LobbyImage.Maps,
            analyticsPopupTriggered: ShareActivityLinkAnalytics.ReferralProgramStorePopupTriggeredLevel2,
            analyticsPopupSuccess: ShareActivityLinkAnalytics.ReferralProgramStoreSuccessfullySharedLevel2,
        },
        {
            referralCount: 10,
            storeItemCategory: StoreItemCategory.Color,
            possibleRewards: [new SIColorWhite(), new SIColorPurple(), new SIColorMysticBlue()],
            name: {key: 'strings:storePage.sections.color.title', options: {context: 'other'}},
            image: LobbyImage.AllColors,
            analyticsPopupTriggered: ShareActivityLinkAnalytics.ReferralProgramStorePopupTriggeredLevel3,
            analyticsPopupSuccess: ShareActivityLinkAnalytics.ReferralProgramStoreSuccessfullySharedLevel3,
        },
        {
            referralCount: 20,
            storeItemCategory: StoreItemCategory.Expansion,
            // eslint-disable-next-line max-len
            possibleRewards: [new SIExpansionSeafarers4P(), new SIExpansionCitiesAndKnights4P(), new SIExpansionClassic56P(), new SIExpansionClassic78P(), new SIExpansionSeafarers56P(), new SIExpansionCitiesAndKnights56P(), new SIExpansionCitiesAndKnightsSeafarers4P(), new SIExpansionCitiesAndKnightsSeafarers56P()],
            name: {key: 'strings:storePage.sections.expansion.title', options: {context: 'other'}},
            image: LobbyImage.Expansions,
            analyticsPopupTriggered: ShareActivityLinkAnalytics.ReferralProgramStorePopupTriggeredLevel4,
            analyticsPopupSuccess: ShareActivityLinkAnalytics.ReferralProgramStoreSuccessfullySharedLevel4,
        },
    ]
}
